export default __webpack_public_path__ + "static/media/TriassicMap.214c148b.jpg";